/**
 * Input box Component
 */
export * from './input';
